<template>
  <div class="order-track">
    <div id="container"></div>
  </div>
</template>

<script>
import { getDriverPosition , geocoder , directionDriving } from "@/api/dispatch/orderTrack/index.js";
export default {
  data(){
    return {
      map:null,
      driverPositionData:{},
      polylineLayer:null,  //地图折线实例
      marker:null,  //地图点标记实例
    }
  },
  async mounted(){
    await Promise.all([
      this.createMap(),
      this.getDriverPosition(),
    ]);
    this.$nextTick(()=>this.initMap());
  },
  methods:{
    async initMap(){
      if(this.map) return false;
      this.reset();
      this.map = new window.TMap.Map("container", {
          rotation: 0,//设置地图旋转角度
          pitch: 0, //设置俯仰角度（0~45）
          zoom: 10,//设置地图缩放级别
      });
      // 根据订单状态画线
      await this.handleDisplayPolylineByOrderState();
      // 获取订单起始地址经纬度
      let shippingReceivingLatLngList = await this.getOrderInfoAddrLatLng();
      //添加起始点和车辆点标记
      await this.handleMultiMarker(shippingReceivingLatLngList);  
      // 设置地图可视范围
      await this.handleLatLngBounds(shippingReceivingLatLngList);
    },
    reset(){
      if(this.marker) {
        this.marker.setMap(null);
        this.marker = null;
      };
      if(this.polylineLayer) {
        this.polylineLayer.setMap(null);
        this.polylineLayer = null;
      }
    },
    // 根据订单状态画线
    async handleDisplayPolylineByOrderState(){
      try {
        let solidPositionList = [],
        solidPl = null,
        dashedPositionList = [],
        dashedPl = null,
        geometries = [],
        driverPosition = null;
        // 处理司机位置经纬度 判断是否存在司机位置
        if(
          this.driverPositionData.driverPosition 
          && this.driverPositionData.driverPosition.latitude 
          && this.driverPositionData.driverPosition.longitude
        ) driverPosition = `${this.driverPositionData.driverPosition.latitude},${this.driverPositionData.driverPosition.longitude}`;
        // 添加实线 (途经点+提货打卡点)按时间正序后 + 司机位置
        solidPositionList = this.handleSolidAdd({ driverPosition });
        // 添加虚线
        if(this.driverPositionData.tmsOrderState <= 4) {
          // 待调度、待接单，此时还未指定司机，所以按照地址顺序用虚线进行路线规划 start1 ---- start2 ---- end1 ---- end2
          dashedPositionList = this.handleNoDriverAssigned();
        }else if(this.driverPositionData.tmsOrderState === 5){
          if(this.driverPositionData.shippingLinkInfo.some(shippingItem=>!shippingItem.isEnd)){
            // 提货点没走完
            if(!this.driverPositionData.shippingLinkInfo.some(shippingItem=>shippingItem.isStart)){
              // 还没到达第一个提货地 driver ---- start1 ---- start2 ---- end1 ---- end2
              // 司机位置 在虚线起点
              dashedPositionList = this.handleNotArrivedOneShipping(driverPosition);
            }else {
              // 至少到达一个提货地 start1 ———— driver ---- start2 ---- end1 ---- end2 
              dashedPositionList = this.handleShippingInOperation(driverPosition);
            }
          }else if(this.driverPositionData.receivingLinkInfo.some(receivingItem=>!receivingItem.isEnd)) {
            // 卸货点没走完
            if(!this.driverPositionData.receivingLinkInfo.some(receivingItem=>receivingItem.isStart)) {
              // 还没到达第一个卸货地 start1 ———— start2 ———— driver ---- end1 ---- end2
              dashedPositionList = this.handleNotArrivedOneReceiving(driverPosition);
            }else {
              // 至少到达了一个卸货地 start1 ———— start2 ———— end1 ———— driver ---- end2
              dashedPositionList = this.handleReceivingInOperation(driverPosition);
            }
          }else {
            // 此时卸货完成 无虚线 但还没回单 start1 ———— start2 ———— 途经点 ———— end1———— end2
          }
        }else if(this.driverPositionData.tmsOrderState >= 6) {
          // 此时回单完成 无虚线
        };
        // 实线路线规划
        if(solidPositionList.length) {
          if(solidPositionList.length < 2) throw new Error("实线经纬度数据不足两个");
          solidPl = await this.directionDriving(solidPositionList);
          geometries.push({
            id: 'pl_solid_' + this.driverPositionData.tmsOrderId, //折线唯一标识，删除时使用
            styleId: 'solid',
            zIndex:999999,
            paths: solidPl
          })
        }
        // 虚线路线规划
        if(dashedPositionList.length) {
          if(dashedPositionList.length < 2) throw new Error("虚线经纬度数据不足两个");
          dashedPl = await this.directionDriving(dashedPositionList);
          geometries.push({
            id: 'pl_dashed_' + this.driverPositionData.tmsOrderId, //折线唯一标识，删除时使用
            styleId: 'dashed',
            zIndex:999999,
            paths: dashedPl
          })
        }
        //显示路线
        let res = await this.display_polyline(geometries); 
        return Promise.resolve(res);
      } catch (error) {
        console.log("handleDisplayPolylineByOrderState error",error);
        // 数据异常时直接展示起点和终点的虚线规划
        let dashedPositionList = [],
        geometries = [];
        let list = this.handleNoDriverAssigned();
        dashedPositionList = list;
        // 虚线路线规划
        if(dashedPositionList.length) {
          if(dashedPositionList.length < 2) return Promise.reject(new Error("起始地址缺失"));
          return this.directionDriving(dashedPositionList)
          .then(dashedPl => {
            geometries.push({
              id: 'pl_dashed_' + this.driverPositionData.tmsOrderId, //折线唯一标识，删除时使用
              styleId: 'dashed',
              zIndex:999999,
              paths: dashedPl
            })
            this.display_polyline(geometries); //显示路线
          })
        }else return Promise.reject(error);
      }
    },
    // 添加实线 (途经点+提货打卡点)按时间正序后 + 司机位置
    handleSolidAdd({ driverPosition }){
      let solidPositionList = [];
      if(this.driverPositionData.tmsOrderPosition && this.driverPositionData.tmsOrderPosition.length) {
          // 途经点
          solidPositionList = solidPositionList.concat(this.driverPositionData.tmsOrderPosition);
        };
        if(this.driverPositionData.shippingLocationItems && this.driverPositionData.shippingLocationItems.length) {
          // 提货打卡点
          solidPositionList = solidPositionList.concat(this.driverPositionData.shippingLocationItems);
        };
        if(this.driverPositionData.receivingLocationItems && this.driverPositionData.receivingLocationItems.length) {
          // 卸货打卡点
          solidPositionList = solidPositionList.concat(this.driverPositionData.receivingLocationItems);
        };
        if(solidPositionList.length) {
          // 时间正序
          solidPositionList = solidPositionList.sort((a,b) => a.sortId - b.sortId).map(item=>`${item.latitude},${item.longitude}`);
          // 添加实线 司机位置 在实线终点
          driverPosition && solidPositionList.length && this.driverPositionData.receivingLinkInfo.some(receivingItem=>!receivingItem.isStart) && solidPositionList.push(driverPosition);
        };
        return solidPositionList;
    },
    // 未指定司机时
    handleNoDriverAssigned(){
      let dashedPositionList = [];
      this.driverPositionData.shippingLinkInfo.map(item=>{
        dashedPositionList.push(`${item.latitude},${item.longitude}`);
      });
      this.driverPositionData.receivingLinkInfo.map(item=>{
        dashedPositionList.push(`${item.latitude},${item.longitude}`);
      });
      return dashedPositionList;
    },
    // 未到达第一个提货点
    handleNotArrivedOneShipping(driverPosition){
      // 还没到达第一个提货地 driver ---- start1 ---- start2 ---- end1 ---- end2
      let dashedPositionList = [];
      this.driverPositionData.shippingLinkInfo.map(item=>{
        dashedPositionList.push(`${item.latitude},${item.longitude}`);
      });
      this.driverPositionData.receivingLinkInfo.map(item=>{
        dashedPositionList.push(`${item.latitude},${item.longitude}`);
      });
      driverPosition && dashedPositionList.length && dashedPositionList.unshift(driverPosition);
      return dashedPositionList;
    },
    // 正在操作提货地
    handleShippingInOperation(driverPosition){
      // 至少到达一个提货地 start1 ———— driver ---- start2 ---- end1 ---- end2 
      let dashedPositionList = [];
      this.driverPositionData.shippingLinkInfo.map(item=>{
        !item.isStart && dashedPositionList.push(`${item.latitude},${item.longitude}`);
      });
      this.driverPositionData.receivingLinkInfo.map(item=>{
        dashedPositionList.push(`${item.latitude},${item.longitude}`);
      });
      driverPosition && dashedPositionList.length && dashedPositionList.unshift(driverPosition);
      return dashedPositionList;
    },
    // 未到达第一个卸货点
    handleNotArrivedOneReceiving(driverPosition){
      // 还没到达第一个卸货地 start1 ———— start2 ———— driver ---- end1 ---- end2
      let dashedPositionList = [];
      this.driverPositionData.receivingLinkInfo.map(item=>{
        dashedPositionList.push(`${item.latitude},${item.longitude}`);
      });
      driverPosition && dashedPositionList.length && dashedPositionList.unshift(driverPosition);
      return dashedPositionList;
    },
    // 正在操作卸货地
    handleReceivingInOperation(driverPosition){
      // 至少到达了一个卸货地 start1 ———— start2 ———— end1 ———— driver ---- end2
      let dashedPositionList = [];
      this.driverPositionData.receivingLinkInfo.map(item=>{
        !item.isStart && dashedPositionList.push(`${item.latitude},${item.longitude}`);
      });
      // 订单只有一个卸货地 且 司机已经到达时就不需要设置虚线了
      driverPosition && dashedPositionList.length && dashedPositionList.unshift(driverPosition);
      return dashedPositionList;
    },
    // 腾讯线路规划
    async directionDriving(list){
      try {
        list = list ? list : [];
        if(list && Array.isArray(list) && list.length <= 1) throw new Error("经纬度数据不足两个",this.deepClone(list));
        let queryParams = {
          from: list.shift(),
          to: list.pop(),
        };
        if(list.length) queryParams.waypoints = (`${list.map(item=>item+";")}`).replace(/;,/g,";").slice(0,-1);
        let ret = await directionDriving(queryParams);
        var coords = ret.result.routes[0].polyline, pl = [];
        //坐标解压（返回的点串坐标，通过前向差分进行压缩）
        var kr = 1000000;
        for (var i = 2; i < coords.length; i++) {
          coords[i] = Number(coords[i - 2]) + Number(coords[i]) / kr;
        }
        //将解压后的坐标放入点串数组pl中
        for (var i = 0; i < coords.length; i += 2) {
          pl.push(new TMap.LatLng(coords[i], coords[i+1]));
        }
        return Promise.resolve(pl);
      } catch (error) {
        console.log("directionDriving error",error)
        return Promise.reject(error)
      }
    },
    // 画线
    display_polyline(geometries){
      //创建 MultiPolyline显示折线
      this.polylineLayer = new TMap.MultiPolyline({
        id: 'polyline-layer' + this.driverPositionData.tmsOrderId, //图层唯一标识
        map: this.map,//绘制到目标地图
        //折线样式定义
        styles: {
          dashed: new TMap.PolylineStyle({
            color: '#c1c1c1', // 线填充色
            width: 6, // 折线宽度
            borderWidth: 1, // 边线宽度
            borderColor: '#EC892E', // 边线颜色
            lineCap: 'round', // 线端头方式
            dashArray: [40, 6] // 虚线展示方式
            // dashArray: [4, 100] // 虚线展示方式
          }),
          'solid': new TMap.PolylineStyle({
            color: '#F1BC3F', // 线填充色
            width: 6, // 折线宽度
            borderWidth: 2, // 边线宽度
            borderColor: '#EC892E', // 边线颜色
            lineCap: 'round', // 线端头方式
            eraseColor: 'rgba(190,188,188,1)',
          }),
        },
        //折线数据定义
        geometries
      });
      return Promise.resolve();
    },
    /* 获取订单起始地址经纬度 */
    async getOrderInfoAddrLatLng(){
      try {
        var _this = this,
        shippingInfo = this.driverPositionData.shippingLinkInfo,
        receivingInfo = this.driverPositionData.receivingLinkInfo,
        orderInfoAddrLatLngList = [];
        // 添加司机位置 (司机位置存在 且 最后一个卸货地到达之前 且 接单后 才展示)
        if(
          this.driverPositionData.driverPosition 
          && this.driverPositionData.driverPosition.latitude 
          && this.driverPositionData.driverPosition.longitude
          && this.driverPositionData.receivingLinkInfo.some(receivingItem=>!receivingItem.isStart)
          && this.driverPositionData.tmsOrderState > 4
        ) orderInfoAddrLatLngList = [{
          id: 'car-style',
          styleId: 'car-style',
          position:new TMap.LatLng(this.driverPositionData.driverPosition.latitude,this.driverPositionData.driverPosition.longitude),
        }]
        if(shippingInfo && shippingInfo.length) {
          for(var i=0;i<shippingInfo.length;i++){
            await (function (){
              return new Promise(async(resolve,reject)=>{
                let addrItem = shippingInfo[i];
                let index = i;
                if(addrItem.longitude&&addrItem.latitude) {
                  // 此时为订单地址信息中存在经纬度
                  // let trackItem = {latitude:addrItem.latitude,longitude:addrItem.longitude,id:`loading${index}`,styleId:'loading'};
                  let trackItem = {
                    id:`loading${index}`,
                    styleId:'loading',
                    position:new TMap.LatLng(addrItem.latitude,addrItem.longitude),
                  };
                  orderInfoAddrLatLngList.unshift(trackItem);
                  resolve(trackItem)
                }else {
                  // 此时为订单地址信息中不存在经纬度 需要使用腾讯地图api将地址转换为经纬度
                  try {
                    let geocoderRes = await _this.handleGeocoder({ addrItem });
                    let trackItem = {
                      id:`loading${index}`,
                      styleId:'loading',
                      position:new TMap.LatLng(geocoderRes.latitude,geocoderRes.longitude),
                    };
                    orderInfoAddrLatLngList.unshift(trackItem)
                    resolve(trackItem)
                  } catch (error) {
                    console.log("getOrderInfoAddrLatLng shipping error",error)
                    resolve({})
                  }
                }
              })
            })()
          }
        }
        if(receivingInfo && receivingInfo.length) {
          for(var j=0;j<receivingInfo.length;j++) {
            await (function(){
              return new Promise(async(resolve,reject)=>{
                let addrItem = receivingInfo[j];
                let index = j;
                if(addrItem.longitude&&addrItem.latitude) {
                  let trackItem = {
                    id:`unload${index}`,
                    styleId:'unload',
                    position:new TMap.LatLng(addrItem.latitude,addrItem.longitude),
                  };
                  orderInfoAddrLatLngList.push(trackItem);
                  resolve(trackItem);
                }else {
                  try {
                    let geocoderRes = await _this.handleGeocoder({ addrItem });
                    let trackItem = {
                      id:`unload${index}`,
                      styleId:'unload',
                      position:new TMap.LatLng(geocoderRes.latitude,geocoderRes.longitude),
                    };
                    orderInfoAddrLatLngList.push(trackItem);
                    resolve(trackItem);
                  } catch (error) {
                    console.log("getOrderInfoAddrLatLng receivingInfo error",error)
                    resolve({})
                  }
                }
              })
            })()
          }
        }
        return Promise.resolve(orderInfoAddrLatLngList);
      } catch (error) {
        console.log("getOrderInfoAddrLatLng err",error)
        return Promise.reject(error);
      }
    },
    /* 地址解析成经纬度 */
    async handleGeocoder({ addrItem }){
      var address = ''
      let addressKey = ['province','city','district','detailedAddress','title','remark'];
      addressKey.map(key=>{
        address += addrItem[key]?addrItem[key]:''
      });
      address = address.replace(`${addrItem.province?addrItem.province:''}${addrItem.city?addrItem.city:''}${addrItem.district?addrItem.district:''}`,'');
      try {
        let { result } = await geocoder({address});
        let { province , city , district , street , street_number } = result.address_components;
        return Promise.resolve({
          province,city,district:district?district:'',
          detailedAddress:province+city+district+street+street_number,
          title:result.title,
          latitude:result.location.lat,
          longitude:result.location.lng
        })
      } catch (error) {
        return Promise.reject(error)
      }
      
    },
    handleMultiMarker(geometries){
      //标记起终点marker
      this.marker = new TMap.MultiMarker({ 
        id: 'marker-layer' + this.driverPositionData.tmsOrderId,
        map: this.map,
        styles: {
          /* "car-style": new TMap.MarkerStyle({
            width: 40,
            height: 40,
            anchor: {
              x: 20,
              y: 20,
            },
            faceTo: 'map',
            rotate: 180,
            src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/car.png',
          }), */
          'car-style': new TMap.MarkerStyle({
            width: 40,
            height: 40,
            anchor: {
              x: 30,
              y: 15,
            },
            faceTo: 'map',
            rotate: 0,
            // src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/car.png',
            src: require('@/assets/image/map-driver-icon.png'),
          }),
          "loading": new TMap.MarkerStyle({
            "width": 25,
            "height": 35,
            "anchor": { x: 16, y: 32 },
            "src": 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/start.png'
          }),
          "unload": new TMap.MarkerStyle({
            "width": 25,
            "height": 35,
            "anchor": { x: 16, y: 32 },
            "src": 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/end.png'
          })
        },
        geometries
      });
    },
    // 设置地图可视范围
    handleLatLngBounds(geometries){
      // 自适应显示多个标记及线路
      var bounds = new TMap.LatLngBounds();
      var vehicleTrajectoryList = this.vehicleTrajectoryList&&this.vehicleTrajectoryList.length?
      this.vehicleTrajectoryList.map(item=>({position:new TMap.LatLng(item.latitude,item.longitude)})):[];
      var markerArr = vehicleTrajectoryList.concat(geometries)
      //判断标注点是否在范围内
      markerArr.forEach(function(item){
        //若坐标点不在范围内，扩大bounds范围
        if(bounds.isEmpty() || !bounds.contains(item.position)){
            bounds.extend(item.position);
        }
      })
      //设置地图可视范围
      this.map.fitBounds(bounds, {
          padding: 100 // 自适应边距
      });
    },
    // 获取司机位置
    getDriverPosition(){
      return getDriverPosition(this.$route.query.orderId)
      .then(({ data }) => {
        // 解析json数据
        ["driverShippingOperationLinkStart","driverShippingOperationLinkEnd","driverReceivingOperationLinkStart","driverReceivingOperationLinkEnd"]
        .map(key => {
          if(this.$test.jsonString(data[key])) data[key] = JSON.parse(data[key]);
        });
        data.shippingLinkInfo.map(shippingItem=>{
          Object.assign(shippingItem,{
            isStart: Boolean(data.driverShippingOperationLinkStart && data.driverShippingOperationLinkStart.find(findItem=>findItem.index === shippingItem.sortId && findItem.latitude === shippingItem.latitude && findItem.longitude === shippingItem.longitude)),
            isEnd:Boolean(data.driverShippingOperationLinkEnd && data.driverShippingOperationLinkEnd.find(findItem=>findItem.index === shippingItem.sortId && findItem.latitude === shippingItem.latitude && findItem.longitude === shippingItem.longitude))
          })
        });
        data.receivingLinkInfo.map(receivingItem=>{
          Object.assign(receivingItem,{
            isStart: Boolean(data.driverReceivingOperationLinkStart && data.driverReceivingOperationLinkStart.find(findItem=>findItem.index === receivingItem.sortId && findItem.latitude === receivingItem.latitude && findItem.longitude === receivingItem.longitude)),
            isEnd:Boolean(data.driverReceivingOperationLinkEnd && data.driverReceivingOperationLinkEnd.find(findItem=>findItem.index === receivingItem.sortId && findItem.latitude === receivingItem.latitude && findItem.longitude === receivingItem.longitude))
          })
        });
        /* if(process.env.NODE_ENV === "development") {
          data.driverPosition = {
            latitude:22.967659,
            longitude:114.039108
          }
        } */
        this.driverPositionData = data;
      })
    },
  }
}
</script>

<style scoped lang="scss">
  .order-track {
    height: 100vh;
    #container {
      height: 100%;
    }
  }
</style>